import { GenIcon } from '../helpers/IconBase.es.js';

const RefreshOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.3719 2.48965C19.3498 2.07603 18.9965 1.75869 18.5829 1.78085C18.1693 1.80301 17.8519 2.15628 17.8741 2.5699L17.9659 4.28366C16.3174 3.00646 14.2461 2.24608 12 2.24608C6.61584 2.24608 2.25 6.61081 2.25 11.9961C2.25 17.3814 6.61584 21.7461 12 21.7461C17.3852 21.7461 21.75 17.3813 21.75 11.9961C21.75 11.3831 21.6938 10.7832 21.5854 10.2C21.5097 9.79279 21.1182 9.52402 20.7109 9.59971C20.3037 9.67541 20.0349 10.0669 20.1106 10.4741C20.2022 10.967 20.25 11.4751 20.25 11.9961C20.25 16.5529 16.5568 20.2461 12 20.2461C7.44416 20.2461 3.75 16.5528 3.75 11.9961C3.75 7.43935 7.44416 3.74608 12 3.74608C13.9066 3.74608 15.6616 4.39206 17.0582 5.47795L15.1388 5.52197C14.7247 5.53147 14.3967 5.87486 14.4062 6.28897C14.4157 6.70307 14.7591 7.03107 15.1732 7.02158L18.8362 6.93758C19.039 6.93293 19.2313 6.84629 19.3692 6.69745C19.5071 6.5486 19.5788 6.35025 19.5679 6.14765L19.3719 2.48965Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { RefreshOutlined };
